/**
 * @generated SignedSource<<799edbc96d0723d58a826111dfef3c4c>>
 * @relayHash dbd39a19103f9f79f145d585b8904952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ceb6fa3f8746ef676b746b22188995177c8f68d74fb12843a001100ee9ea59fb

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentProfileCardContainerQuery$variables = {
  agentAri: string;
  cloudId: string;
  fetchByIdentity: boolean;
  identityAccountId: string;
};
export type AgentProfileCardContainerQuery$data = {
  readonly agentStudio_agentById?: {
    readonly __typename: "AgentStudioAssistant";
    readonly AgentProfileCard_agentRef: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentProfileCard_agentRef">;
    } | null | undefined;
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly agentStudio_agentByIdentityAccountId?: {
    readonly __typename: "AgentStudioAssistant";
    readonly AgentProfileCard_agentRef: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentProfileCard_agentRef">;
    } | null | undefined;
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type AgentProfileCardContainerQuery = {
  response: AgentProfileCardContainerQuery$data;
  variables: AgentProfileCardContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchByIdentity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identityAccountId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  (v5/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentProfileCard_agentRef"
            }
          ],
          "type": "AgentStudioAssistant"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "AgentProfileCard_agentRef"
      }
    ],
    "type": "AgentStudioAssistant"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "identityAccountId"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = [
  (v5/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      (v9/*: any*/),
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "icon"
      },
      {
        "kind": "ScalarField",
        "name": "identityAccountId"
      },
      {
        "kind": "ScalarField",
        "name": "externalConfigReference"
      },
      {
        "kind": "ScalarField",
        "name": "isFavourite"
      },
      {
        "kind": "ScalarField",
        "name": "conversationStarters"
      },
      {
        "kind": "ScalarField",
        "name": "creatorType"
      },
      {
        "kind": "ScalarField",
        "name": "forgeCreator"
      },
      {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountStatus"
              }
            ],
            "type": "AtlassianAccountUser"
          },
          (v6/*: any*/)
        ]
      },
      {
        "concreteType": "TeamV2",
        "kind": "LinkedField",
        "name": "authoringTeam",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          {
            "kind": "ScalarField",
            "name": "profileUrl"
          },
          (v6/*: any*/)
        ]
      },
      {
        "concreteType": "AgentStudioAgentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canEdit"
          },
          {
            "kind": "ScalarField",
            "name": "canDelete"
          }
        ]
      }
    ],
    "type": "AgentStudioAssistant"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentProfileCardContainerQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v7/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v7/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentProfileCardContainerQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ceb6fa3f8746ef676b746b22188995177c8f68d74fb12843a001100ee9ea59fb",
    "metadata": {},
    "name": "AgentProfileCardContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3c05ffd89ba1297aa141a5fb8817be5f";

export default node;
